"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextButtonIcon = void 0;
var _TextButtonIcon = require("./TextButtonIcon");
// TODO: in v9, move styled() from TextButtonIcon.jsx to here
var StyledTextButtonIcon = _TextButtonIcon.TextButtonIcon;
exports.StyledTextButtonIcon = StyledTextButtonIcon;